import { GlKeysetPagination } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import EMPTY_SVG_URL from '@gitlab/svgs/dist/illustrations/empty-state/empty-ai-catalog-md.svg?url';
import ResourceListsEmptyState from '../../../../../../../app/assets/javascripts/vue_shared/components/resource_lists/empty_state.vue?vue3';
import AiCatalogListSkeleton from './ai_catalog_list_skeleton.vue';
import AiCatalogMcpServerListItem from './ai_catalog_mcp_server_list_item.vue?vue3';
export default {
    name: 'AiCatalogMcpServerList',
    components: {
        AiCatalogListSkeleton,
        AiCatalogMcpServerListItem,
        GlKeysetPagination,
        ResourceListsEmptyState
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        pageInfo: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        emptyStateTitle: {
            type: String,
            required: true
        },
        emptyStateDescription: {
            type: String,
            required: false,
            default: null
        },
        showRoute: {
            type: String,
            required: false,
            default: null
        },
        showConnect: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'next-page',
        'prev-page',
        'connect',
        'disconnected'
    ],
    EMPTY_SVG_URL
};
